import { create } from 'zustand'

export type ViewType =
  | 'dashboard'
  | 'newsletter'
  | 'social-media'
  | 'reports'
  | 'support'
  | 'terms'
  | 'privacy'
  | 'settings'
  | 'sponsorships'
  | 'inventory'
  | 'partners'

interface UIState {
  // State
  sidebarCollapsed: boolean

  // Actions
  setSidebarCollapsed: (collapsed: boolean) => void
  resetUIState: () => void
}

export const useUIStore = create<UIState>((set) => ({
  // Initial state
  sidebarCollapsed: false,

  // Actions
  setSidebarCollapsed: (collapsed) => {
    set({ sidebarCollapsed: collapsed })
  },

  resetUIState: () => {
    set({
      sidebarCollapsed: false
    })
  }
}))
